import { render, staticRenderFns } from "./Bar.vue?vue&type=template&id=06e03132&scoped=true"
import script from "./Bar.vue?vue&type=script&lang=js"
export * from "./Bar.vue?vue&type=script&lang=js"
import style0 from "./Bar.vue?vue&type=style&index=0&id=06e03132&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e03132",
  null
  
)

export default component.exports